import * as React from 'react'
import {ReactElement} from 'react'
import {Box} from '@mui/material';
import {Colors, FontSize} from '../../../../styledComponents/Constants'
import {FullWidthColumnFlexContainer, LeftRowFlexContainer} from '../../../../styledComponents/FlexComponents'
import {BlockSpacer} from '../../../../styledComponents/ResponsiveConvenience'
import {Location} from 'react-router-dom'
import {Nullable} from '../../../../app/TypeHelpers'
import {
    ApplyButton,
    BoldText,
    ListGridContainer,
    PageTitle,
    PledgeArea,
    PolicyCheckBoxStyled,
    WideWhiteArea
} from '../common/resident/NatResidentApplicationsCommon'
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet
} from '../../../../components/shared/hoc/createResidentWithErrorHandlingPage'
import styled from 'styled-components'
import {CenterPlainLinkStyledButton} from '../../../../styledComponents/Button'
import {InlineLink} from '../../../../styledComponents/residentPage/Links'
import {NatResidentStepper} from '../../common/resident/NatResidentStepper'
import {BreakPcOnly} from '../../../../styledComponents/DisplayItem'

interface Props {
    location: Location
}

interface State {
    policyChecked: boolean
}

class NatResidentUserRegistrationAgreementPage
    extends React.Component<Props & ResidentWithErrorHandlingPagePropsSet, State> {

    constructor(props: Props & ResidentWithErrorHandlingPagePropsSet) {
        super(props)

        this.state = {
            policyChecked: false
        }

        this.onClickFirstLoginLink = this.onClickFirstLoginLink.bind(this)
        this.onChangePolicyChecked = this.onChangePolicyChecked.bind(this)
        this.onClickApplyButton = this.onClickApplyButton.bind(this)
        this.onClickBackLoginLink = this.onClickBackLoginLink.bind(this)
    }

    onChangePolicyChecked(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({policyChecked: event.target.checked})
    }

    onClickFirstLoginLink(): void {
        this.props.navigate('/resident/firstLoginPolicyAgree')
    }

    onClickApplyButton(): void {
        this.props.navigate('/resident/noAuthenticationKey/condominiumRegister')
    }

    onClickBackLoginLink(): void {
        this.props.navigate('/resident/login')
    }

    renderPolicy(): Nullable<ReactElement> {

        return (<>
            <Box height={'15px'}/>
            <PledgeArea fontSize={FontSize.Middle}>
                <Box p={'10px'}>
                    <PolicyBoldText fontColor={Colors.AccentDark}>【個人情報のお取扱いについて】</PolicyBoldText>
                    <Box height={'5px'}/>
                    お客様の個人情報は、当社の基本姿勢とその取扱い基準を明確化した個人情報規程（JIS Q15001）に準拠し管理させて頂きますので、<br/>
                    以下の項目をご理解いただいた上でご利用ください。
                    <Box height={'20px'}/>
                    <ListGridContainer fontSize={FontSize.Middle}>
                        <PolicySection>1.</PolicySection>
                        <div>
                            当社は、お客様の個人情報を、以下に定める目的のみで収集・利用し、これ以外の目的に利用することはありません。<br/>
                            ・マンションポータルサイト「素敵ネット」初回登録の為のご本人様確認
                        </div>
                        <PolicySection>2.</PolicySection>
                        <div>
                            前項のサービス提供にあたり、お客様の個人情報は、個人情報を適切に管理することを契約等で義務付けた提携協力業者以外の第三者に公開することはありません。
                        </div>
                        <PolicySection>3.</PolicySection>
                        <div>
                            当社にご提供いただいた個人情報に関して、開示のご請求や開示の結果、誤記等がありました場合は、下記連絡先までお知らせください。
                        </div>
                        <PolicySection>4.</PolicySection>
                        <div>
                            個人情報お問合せ先<br/>
                            〔東京〕〒105-0014　東京都港区芝2-6-1<br/>
                            ㈱長谷工コミュニティ 常務執行役員 笠原 徹<br/>
                            <Box ml={'25px'}>
                                TEL：03-3457-1217　FAX：03-3457-1004<br/>
                                Eメール：pp-hcm@haseko.co.jp<br/>
                            </Box>
                            〔関西〕〒541-0051　大阪府大阪市中央区備後町2-1-1<br/>
                            ㈱長谷工コミュニティ 取締役兼常務執行役員 永平 貴嗣<br/>
                            <Box ml={'25px'}>
                                TEL：06-6201-5165　FAX：06-6201-5092<br/>
                                Eメール：pp-hcm@haseko.co.jp<br/>
                            </Box>
                        </div>
                    </ListGridContainer>
                    <Box height={'10px'}/>
                </Box>
            </PledgeArea>
            <Box height={'20px'}/>
            <FullWidthColumnFlexContainer>
                <PolicyCheckBoxStyled>
                    <LeftRowFlexContainer>
                        <input
                            type="checkbox"
                            checked={this.state.policyChecked}
                            onChange={this.onChangePolicyChecked}
                        />
                        <BlockSpacer width={'10px'}/>
                        確認しました
                    </LeftRowFlexContainer>
                </PolicyCheckBoxStyled>
            </FullWidthColumnFlexContainer>
        </>)
    }

    render(): ReactElement {
        return (
            <>
                <BlockSpacer height={'30px'}/>
                <NatResidentStepper
                    stepList={[
                        {label: '手続き説明', isActive: true},
                        {label: <>マンション・<BreakPcOnly/>メールアドレス登録</>},
                        {label: 'メール受信'},
                        {label: '申請者情報登録'},
                        {label: '申請者情報確認'},
                        {label: '申請提出完了', isSquare: true}
                    ]}
                />
                <BlockSpacer height={'30px'}/>
                <PageTitle>
                    素敵ネットユーザ登録申請
                </PageTitle>
                <Box height={'20px'}/>
                <Box>
                    素敵ネットにユーザ登録するための申請を行います。申請が承認されると、ユーザ登録ができるようになります。
                    <Box height={'10px'}/>
                    <ListGridContainer fontSize={FontSize.Middle}>
                        <div>・</div>
                        <div>本人による提出かどうかを確認するために、管理費等の引落口座の口座番号の入力が必要になります。</div>
                        <div>・</div>
                        <div>本人確認の審査に、数日お時間をいただきます。認証キーをお持ちの場合は、
                            <GridItemLink onClick={this.onClickFirstLoginLink}>
                                こちら
                            </GridItemLink>
                            からご登録をお願いいたします。
                        </div>
                    </ListGridContainer>
                </Box>
                <Box height={'15px'}/>
                <WideWhiteArea>
                    <Box mt={'15px'}>
                        <BoldText fontColor={Colors.AccentDark}>ご準備いただくもの</BoldText>
                        <Box height={'5px'}/>
                        <ListGridContainer fontSize={'16px'}>
                            <div>・</div>
                            <div>管理費等の引落口座の口座番号が分かる通帳やキャッシュカード等</div>
                        </ListGridContainer>
                        <Box height={'20px'}/>
                    </Box>
                </WideWhiteArea>
                {this.renderPolicy()}
                <ApplyButton
                    disabled={!this.state.policyChecked}
                    onClick={this.onClickApplyButton}>
                    <FullWidthColumnFlexContainer>
                        <div>次へ進む</div>
                    </FullWidthColumnFlexContainer>
                </ApplyButton>
                <Box mt={'30px'}/>
                <CenterPlainLinkStyledButton onClick={this.onClickBackLoginLink}>
                    ログイン画面へ戻る
                </CenterPlainLinkStyledButton>
                <BlockSpacer height={'30px'}/>
            </>
        )
    }
}

export default createResidentWithErrorHandlingPage(NatResidentUserRegistrationAgreementPage)

const PolicyBoldText = styled(BoldText)`
  font-size: ${FontSize.Middle};
`
const GridItemLink = styled(InlineLink)`
  cursor: pointer;
`
const PolicySection = styled.div`
  margin-left: 20px;
  margin-right: 5px;
`
